import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

/**
 * Плеер видеоурока с честным учётом просмотра.
 *
 * Считаем не позицию ползунка, а реально просмотренные секунды: перемотка
 * вперёд не добавляет прогресс. Каждые 10 секунд (и на паузе/в конце)
 * отправляем прогресс на бэкенд — он открывает тест и закрывает урок.
 */
export const LessonVideo = ({ lessonId, videoUrl, poster, requiredPercent = 80,
                              startPercent = 0, onProgress, track = true }) => {
  const ref = useRef(null);
  const watched = useRef(0);          // накопленные просмотренные секунды
  const lastTime = useRef(0);
  const lastSent = useRef(0);
  const [percent, setPercent] = useState(startPercent || 0);

  const src = videoUrl?.startsWith("http")
    ? videoUrl
    : `${process.env.REACT_APP_BACKEND_URL}${videoUrl}`;

  const push = async (p, seconds) => {
    if (!track || !lessonId) return;
    try {
      const r = await axios.post(`${API}/academy/lessons/${lessonId}/watch`,
        { percent: Math.round(p), seconds: Math.round(seconds) },
        { withCredentials: true });
      if (onProgress) onProgress(r.data);
    } catch { /* прогресс не критичен для просмотра */ }
  };

  const onTime = () => {
    const v = ref.current;
    if (!v || !v.duration || !isFinite(v.duration)) return;
    const delta = v.currentTime - lastTime.current;
    lastTime.current = v.currentTime;
    if (delta > 0 && delta < 2) watched.current += delta;   // перемотку не считаем
    const p = Math.min(100, (watched.current / v.duration) * 100);
    if (p > percent) setPercent(p);
    if (v.currentTime - lastSent.current >= 10) {
      lastSent.current = v.currentTime;
      push(Math.max(p, percent), watched.current);
    }
  };

  const flush = () => {
    const v = ref.current;
    if (!v) return;
    push(percent, watched.current);
  };

  useEffect(() => () => flush(), []);   // eslint-disable-line react-hooks/exhaustive-deps

  const done = percent >= requiredPercent;

  return (
    <div data-testid="lesson-video">
      <video ref={ref} src={src} poster={poster || undefined} controls
        playsInline preload="metadata"
        onTimeUpdate={onTime} onPause={flush} onEnded={() => { setPercent(100); push(100, watched.current); }}
        style={{ width: "100%", maxHeight: 460, background: "#000",
                  borderRadius: 10, display: "block" }} />
      <div style={{ marginTop: 8 }}>
        <div style={{ height: 5, background: "#eee", borderRadius: 999, overflow: "hidden" }}>
          <div data-testid="lesson-video-progress"
            style={{ width: `${Math.min(100, percent)}%`, height: "100%",
                      background: done ? "#059669" : "#C5A059",
                      transition: "width 0.4s ease" }} />
        </div>
        <div style={{ fontFamily: "Manrope", fontSize: 11.5, color: "#8a8a89", marginTop: 5 }}>
          {done
            ? "Просмотрено — тест открыт"
            : `Просмотрено ${Math.round(percent)}% · нужно ${requiredPercent}%, чтобы открыть тест`}
        </div>
      </div>
    </div>
  );
};

export default LessonVideo;
